module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Création du dossier en cours...","video1":"Comment utiliser notre outil de sélection rapide"},"en":{"a":"Your CV is being created...","video1":"How to use our quick selection tool"}}')
  delete Component.options._Ctor
}
